import React, { useState } from "react";
import { validarPIN } from "../utils/masterPin";

export default function PinModal({ onClose, onSuccess }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");

  const verificar = () => {
    if (validarPIN(pin)) {
      onSuccess();
      onClose();
    } else {
      setError("PIN incorrecto");
    }
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl w-80">
        <h2 className="text-lg font-bold text-slate-800 mb-3">
          Ingresar PIN maestro
        </h2>

        <input
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          className="w-full border px-3 py-2 rounded-lg mb-2"
          placeholder="•••••"
        />

        {error && (
          <p className="text-red-500 text-xs mb-2">{error}</p>
        )}

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 text-slate-500 hover:text-slate-700"
          >
            Cancelar
          </button>
          <button
            onClick={verificar}
            className="px-4 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
          >
            Validar
          </button>
        </div>
      </div>
    </div>
  );
}
